export const APPLY_TO_TEXT = {
  SELECTED: 'Selected',
  ALL: 'All',
  HEADER: 'Header',
  BODY: 'Body',
  COLUMN: 'Current column',
  ALTERNATING_ROWS: 'Alternating rows',
};

export const APPLY_TO_VALUES = {
  SELECTED: 'selected',
  ALL: 'all',
  HEADER: 'header',
  BODY: 'body',
  COLUMN: 'column',
  ALTERNATING_ROWS: 'alternating-rows'
};

export const BORDER_STYLE_OPTIONS = [
  'none',
  'solid',
  'dashed'
]

export const APPLY_TO_BORDERS_LABEL = {
  ALL: 'All',
  OUTER: 'Outer',
  INNER: 'Inner',
  LEFT: 'Left',
  RIGHT: 'Right',
  TOP: 'Top',
  BOTTOM: 'Bottom',
}

export const APPLY_TO_BORDERS_VALUES = {
  ALL: 'all',
  OUTER: 'outer',
  INNER: 'inner',
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  BOTTOM: 'bottom',
}

export const APPLY_TO_BORDERS_HANDLERS = {
  [APPLY_TO_BORDERS_VALUES.ALL]: 'setAllBorders',
  [APPLY_TO_BORDERS_VALUES.OUTER]: 'setOuterBorders',
  [APPLY_TO_BORDERS_VALUES.INNER]: 'setInnerBorders',
  [APPLY_TO_BORDERS_VALUES.LEFT]: 'setOneBorder',
  [APPLY_TO_BORDERS_VALUES.RIGHT]: 'setOneBorder',
  [APPLY_TO_BORDERS_VALUES.TOP]: 'setOneBorder',
  [APPLY_TO_BORDERS_VALUES.BOTTOM]: 'setOneBorder',
}

export const CELL_ANGLE_STYLE_RULE = 'cell-angle';

// Angle the cell's stored Height / Min Width were fitted for, so a fit runs once per angle.
export const CELL_ANGLE_FITTED_RULE = 'cell-angle-fitted';

// Bounding box the fit measured for the rotated text (paddings included). Rotated text is out
// of flow, so aligning it needs a size CSS cannot derive on its own.
export const CELL_ANGLE_FIT_WIDTH_RULE = 'cell-angle-fit-width';
export const CELL_ANGLE_FIT_HEIGHT_RULE = 'cell-angle-fit-height';

export const CELL_ALIGNMENTS = [
  { value: 'left,top', text: '┍ left, top' },
  { value: 'center,top', text: '┯ center, top' },
  { value: 'right,top', text: '┑ right, top' },
  { value: 'left,middle', text: '┡ left, center' },
  { value: 'center,middle', text: '╇ center, center' },
  { value: 'right,middle', text: '┥ right, center' },
  { value: 'left,bottom', text: '┕ left, bottom' },
  { value: 'center,bottom', text: '┻ center, bottom' },
  { value: 'right,bottom', text: '┙ right, bottom' },
];

export const DEFAULT_CELL_HORIZONTAL_ALIGN = 'left';

// Table cells inherit `middle` from the UA stylesheet, so that is what an unset cell renders as.
export const DEFAULT_CELL_VERTICAL_ALIGN = 'middle';

export const ALLOWED_STYLES_TO_APPLY_TO_ALL = [
  'font-size',
  'color',
  'font-family',
  'text-align',
  'vertical-align',
  'font-family',
  'background-color',
  'border-color',
  'width',
  'min-width',
  CELL_ANGLE_STYLE_RULE,
];

export const BORDER_STYLE_RULES = {
  BORDER_COLOR: 'border-color',
  TC_BORDER_COLOR: 'tc-border-color',
  BORDER_STYLE: 'border-style',
  BORDER_WIDTH: 'border-width',
}

export const BORDERS = {
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  BOTTOM: 'bottom',
}

const BORDER_COLOR_BORDERS = {
  [BORDERS.LEFT]: 'border-left-color',
  [BORDERS.RIGHT]: 'border-right-color',
  [BORDERS.TOP]: 'border-top-color',
  [BORDERS.BOTTOM]: 'border-bottom-color',
}

const TC_BORDER_COLOR_BORDERS = {
  [BORDERS.LEFT]: 'tc-border-left-color',
  [BORDERS.RIGHT]: 'tc-border-right-color',
  [BORDERS.TOP]: 'tc-border-top-color',
  [BORDERS.BOTTOM]: 'tc-border-bottom-color',
}

const BORDER_STYLE_BORDERS = {
  [BORDERS.LEFT]: 'border-left-style',
  [BORDERS.RIGHT]: 'border-right-style',
  [BORDERS.TOP]: 'border-top-style',
  [BORDERS.BOTTOM]: 'border-bottom-style',
}

const BORDER_WIDTH_BORDERS = {
  [BORDERS.LEFT]: 'border-left-width',
  [BORDERS.RIGHT]: 'border-right-width',
  [BORDERS.TOP]: 'border-top-width',
  [BORDERS.BOTTOM]: 'border-bottom-width',
}

export const BORDER_STYLES = {
  [BORDER_STYLE_RULES.BORDER_COLOR]: BORDER_COLOR_BORDERS,
  [BORDER_STYLE_RULES.BORDER_STYLE]: BORDER_STYLE_BORDERS,
  [BORDER_STYLE_RULES.BORDER_WIDTH]: BORDER_WIDTH_BORDERS,
  [BORDER_STYLE_RULES.TC_BORDER_COLOR]: TC_BORDER_COLOR_BORDERS
}

export const CELL_STYLE_KEYS = [
  'background-color',
  'color',
  'font-size',
  'text-align',
  'font-family',
  'width',
  'min-width',
];

export const ROW_STYLE_KEYS = ['height'];

export const CELL_BORDER_STYLE_KEYS = [
  BORDER_STYLE_RULES.BORDER_COLOR,
  BORDER_STYLE_RULES.BORDER_WIDTH,
  BORDER_STYLE_RULES.BORDER_STYLE,
  BORDER_STYLE_RULES.TC_BORDER_COLOR,
];

export const TC_BORDER_COLOR_KEYS = {
  DISABLED: 'disabled',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

export const TC_BORDER_COLORS = [
  {'key': TC_BORDER_COLOR_KEYS.DISABLED, 'label': 'Disabled'},
  {'key': TC_BORDER_COLOR_KEYS.PRIMARY, 'label': 'Primary'},
  {'key': TC_BORDER_COLOR_KEYS.SECONDARY, 'label': 'Secondary'},
]
